// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__2pb3y","fade--in":"styles_fade--in__3huQu"};